import {
  ForwardedRef,
  FocusEvent as ReactFocusEvent,
  KeyboardEvent as ReactKeyboardEvent,
  MouseEvent as ReactMouseEvent,
  ReactNode,
} from 'react';
import { TooltipPreference } from '../../../Tooltip/Tooltip';
import { InputSize } from '../../Input/types/enums';
export interface ScheduleEventType {
  e: ReactKeyboardEvent | ReactMouseEvent;
  dateTime?: Date;
  selectRange: boolean;
  dateTimeTo: Date;
  onChange?: (dateTime?: Date, dateTimeTo?: Date, e?: ReactKeyboardEvent | ReactMouseEvent | ReactFocusEvent) => void;
  setScheduledDateTime: (date?: DateObj) => void;
  setScheduledDateTimeTo: (date: DateObj) => void;
  handleCalendarVisibility: (e: ReactKeyboardEvent | ReactMouseEvent, show: boolean) => void;
}
export interface DateTimeTextType {
  scheduledDateTime?: DateObj;
  scheduledDateTimeTo: DateObj;
  showTime: boolean;
  selectRange: boolean;
}
export interface DateObj {
  year: number;
  month: number;
  date: number;
  time?: string;
}

export interface CalendarProps {
  showFullCalendar?: boolean;
  showDateContainer?: boolean;
  onChange?: (dateTime?: Date, dateTimeTo?: Date, e?: ReactKeyboardEvent | ReactMouseEvent | ReactFocusEvent) => void;
  disabledDates?: Date[];
  disabledPastDates?: boolean;
  disabledFutureDates?: boolean;
  disabledPastNDates?: number;
  timeLabel?: string;
  timeLabelStart?: string;
  timeLabelEnd?: string;
  showTime?: boolean;
  selectRange?: boolean;
  onNavigate?: (year: number, month: number, e: ReactKeyboardEvent | ReactMouseEvent) => void;
  value?: Date;
  valueTo?: Date;
  forwardedRef?: ForwardedRef<HTMLDivElement>;
  ariaLabel?: string;
  calendarTitle?: string;
  /**
   * @description calendar will only show 28 days
   */
  show4WeeksOnly?: boolean;
  setSelectedMonthYear?: [];
}

export type DatePickerProps = Omit<CalendarProps, 'ref'> & {
  inputLabel?: string;
  labelInfo?: string;
  labelInfoPreference?: TooltipPreference;
  placeholder?: string;
  cancelLabel?: string;
  scheduleLabel?: string;
  isWithinModal?: boolean;
  onCalendarToggle?: (e: ReactKeyboardEvent | ReactMouseEvent) => void;
  onSelect?: (e?: ReactKeyboardEvent | ReactMouseEvent | ReactFocusEvent) => void;
  displayText?: string;
  description?: string;
  calendarHeading?: string;
  calendarFooter?: ReactNode;
  inputContainerHeight?: string;
  ariaLabel?: string;
  disabled?: boolean;
  actionButtonStyle?: {};
  readOnly?: boolean;
  required?: boolean;
  containerWidth?: string;
  onClose?: (e: ReactKeyboardEvent | ReactMouseEvent) => void;
  onClear?: (e: ReactMouseEvent) => void;
  allowRemove?: boolean;
  calendarContainerStyling?: {};
  menuContainerStyle?: {};
  inputSize?: InputSize;
  contentHeight?: string;
};
export const DAY_LIMIT = 28;
export const PLACEHOLDER_TEXT = 'placeholderText';

export type KeyEvent = ReactKeyboardEvent | ReactMouseEvent | ReactFocusEvent;
export type HandleStartAndEndSelectionProps = {
  selectDate: Date;
  selectedDateTime: Date;
  selectedDateTimeEnd: Date;
  setSelectedDateTime: React.Dispatch<React.SetStateAction<Date>>;
  setSelectedDateTimeEnd: React.Dispatch<React.SetStateAction<Date>>;
  setSelectedDateTimeEndHover: React.Dispatch<React.SetStateAction<Date>>;
  minValue: Date;
  e: KeyEvent;
  onChange?: (dateTime?: Date, dateTimeTo?: Date, e?: ReactKeyboardEvent | ReactMouseEvent | ReactFocusEvent) => void;
};

export interface WeekSpanProps {
  displayDate: { date: number; month: number } | false;
  isSelected: { date: number; month: number } | false;
  isSelectedFrom: { date: number; month: number } | false;
  isSelectedTo: boolean;
  isSelectedRange: boolean;
  isDisabled: boolean;
  j: number;
  i: number;
  onClickHandler: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onKeyDownHandler: (e: React.KeyboardEvent<HTMLSpanElement>) => void;
  onMouseOverHandler: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onFocusHandler: (e: React.FocusEvent<HTMLSpanElement>) => void;
  ariaLabel: string;
}
